import cx from 'classnames'
import { ComponentType } from 'react'
import { Button, Input, InputProps } from 'reactstrap'

export const ButtonCheck: ComponentType<InputProps & { label: string }> = ({ label, ...props }) => (
  <Button
    tag="label"
    color={props.checked ? 'primary' : 'athens-gray'}
    className={cx('text-left font-size-15 py-10 px-25 border-0', {
      'text-raven': !props.checked,
    })}
    block
  >
    {label}
    <Input {...props} style={{ display: 'none' }} />
  </Button>
)
